<template>
  <div class="main-body">
    <header class="app-header">
      <div class="header-wrapper">
        <div class="logo-wrapper">
          教育云办公平台
        </div>
        <div class="personal-wrapper">
          <img class="user-icon" src="@/assets/img/user_icon.png">
          <span class="user-label">账户</span>
        </div>
      </div>
    </header>
    <main class="layout-main">
      <div class="layout-wrapper">
        <div v-for="(item,index) in sysList" :key="index" class="sys-item" @click="handlerJump(item.jumpPath)">
          <img class="sys-icon" :src="item.iconPath">
          <span class="sys-label">{{ item.sysName }}</span>
        </div>
      </div>
    </main>
    <footer class="footer">
      <!-- Copyright 2019 | 湖南新云网科技有限公司 | 湘ICP备18015340号-2 | 客服热线0731-84457797 | 版本号：v3.0.0 -->
    </footer>
  </div>
</template>

<script>
export default {
  name: 'ErrorLog',
  components: {},
  data() {
    return {
      sysList: [
        {
          sysName: '荣誉管理系统',
          iconPath: require('@/assets/img/honer_sys.png'),
          jumpPath: 'https://honor-dev.cunwedu.com.cn/#/login'
        }, {
          sysName: '区域OA工作台',
          iconPath: require('@/assets/img/oaUser_sys.png'),
          jumpPath: 'https://eduoa-dev.cunwedu.com.cn/login'
        }, {
          sysName: '教师研训平台',
          iconPath: require('@/assets/img/teacherResearch_sys.png'),
          jumpPath: 'http://cf-dev.cunwedu.com.cn/web/#/login'
        }, {
          sysName: '区域OA管理',
          iconPath: require('@/assets/img/oaBack_sys.png'),
          jumpPath: 'https://eduoa-back-dev.cunwedu.com.cn/home'
        }
      ]
    };
  },
  computed: {},
  watch: {},
  mounted() {

  },
  methods: {
    handlerJump(url) {
      window.open(`${url}?token=${this.getQueryString('token')}`, '_blank');
    },
    getQueryString(variable) {
      var reg = new RegExp('(^|&)' + variable + '=([^&]*)(&|$)', 'i');
      const cutStr = window.location.hash;
      const startIndex = cutStr.indexOf('?');
      var r = cutStr.substr(startIndex).substring(1).match(reg);
      if (r != null) return unescape(r[2]); return null;
    }
  }
};
</script>

<style lang="scss" scoped>
.main-body {
  background: #f0f2f5;
  height: 100vh;
  .app-headerv{
    max-height: 62px;
    color: #fff;
    border-bottom: 2px solid #007afc;
    background: #007afc;
  }
  .header-wrapper,.layout-main,.footer {
    margin: 0 auto;
    width: 1200px;
  }
  header {
    width: 100%;
    height: 100px;
    background: #334EB4;
    color: #FFFFFF;
    .logo-wrapper{
      font-size: 33px;
      float: left;
      line-height: 100px;
    }
    .personal-wrapper {
      float: right;
      display: flex;
      flex-direction: column;
      height: 100px;
      justify-content: center;
      text-align: center;
    }
    .user-label {
      padding-top: 7px;
    }
  }
  .layout-main {
    .sys-item {
      width: 188px;
      height: 192px;
      background-color: #FFFFFF;
      margin-right: 60px;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .layout-wrapper {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 83px;
    }
    .sys-icon {
      width: 100px;
      height: 100px;
      background-repeat: no-repeat;
      background-size: 100%;
    }
    .sys-label{
      padding-top: 16px;
    }

  }
  .footer {
    color: #999999;
    padding-bottom: 58px;
    position: fixed;
    bottom: 0px;
    width: 100%;
    text-align: center;
  }
}
</style>
